// ** Redux
import { useDispatch, useSelector } from "react-redux";
import { getPosts } from "store/modules/main-pages/posts/get-posts.action";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import SelectorSelectMulti from "components/layout/DropdownSelectors/SelectorSelectMulti";

// ** Utils & Helpers
import filterSexFn from "helpers/mediaFilters/filterSex";

// #####################################################

export const PostsSexFilter = () => {
	const { t } = useTranslation(["common"]);

	const dispatch = useDispatch();

	const searchSexFromStore = useSelector(
		(state) => state.sharedFilters.searchSex
	);

	const filterSex = filterSexFn({
		gender: searchSexFromStore,
		t,
	});

	const handleSexSelect = (value) => {
		const newFilterSex = filterSexFn({
			gender: value,
			t,
		});

		dispatch(
			getPosts({
				filters: {
					sex: newFilterSex.selectedAsString,
				},
			})
		);
	};

	return (
		<SelectorSelectMulti
			label={t("common:gender")}
			emptyText={t("common:any.2")}
			items={filterSex.array}
			selected={filterSex.selected}
			onAccept={handleSexSelect}
			withMobileVersion
		/>
	);
};

// #####################################################

export default PostsSexFilter;

// #####################################################
